import { formatarBRL, formatarDataBR } from '@truefinance/shared';
import type { Transacao } from '../api/cliente.js';
import { Badge, BadgeOrigem } from './Badge.js';

/**
 * Linha de transação, compartilhada por Dashboard, Transações e Revisão.
 *
 * Regras tipográficas do handoff aplicadas aqui e não em cada tela: valor e
 * data em IBM Plex Mono, valor colorido por tipo, badge sempre com ícone e
 * texto.
 */
export function LinhaTransacao({
  transacao,
  categoria,
  aoClicar,
}: {
  transacao: Transacao;
  // `| undefined` explícito por causa de exactOptionalPropertyTypes: o nome da
  // categoria vem de um Map, que devolve undefined quando a chave não existe.
  categoria?: string | null | undefined;
  aoClicar?: (() => void) | undefined;
}) {
  const ehEntrada = transacao.tipo === 'entrada';

  return (
    <button
      type="button"
      onClick={aoClicar}
      disabled={!aoClicar}
      className={`flex w-full items-center gap-3 border-b border-borda-sutil px-3 py-2.5 text-left last:border-b-0 ${
        aoClicar ? 'hover:bg-hover-linha' : 'cursor-default'
      }`}
    >
      <span className="mono w-[86px] shrink-0 text-[length:var(--text-metadado)] text-texto-terciario">
        {formatarDataBR(transacao.dataOcorrencia)}
      </span>

      <span className="min-w-0 flex-1">
        <span className="block truncate text-[length:var(--text-corpo)] text-texto">
          {transacao.descricao}
        </span>
        <span className="mt-0.5 flex flex-wrap items-center gap-1.5">
          {categoria && (
            <span className="text-[length:var(--text-metadado)] text-texto-terciario">
              {categoria}
            </span>
          )}
          {transacao.contraparte && (
            <span className="text-[length:var(--text-metadado)] text-texto-terciario">
              · {transacao.contraparte}
            </span>
          )}
          <BadgeOrigem origem={transacao.origem} />
        </span>
      </span>

      <span className="hidden shrink-0 sm:block">
        {transacao.status === 'pendente_revisao' ? (
          <Badge variante="pendente" />
        ) : (
          <Badge variante={ehEntrada ? 'entrada' : 'saida'} />
        )}
      </span>

      <span
        className={`mono w-[110px] shrink-0 text-right font-semibold ${
          ehEntrada ? 'text-entrada' : 'text-saida'
        }`}
      >
        {ehEntrada ? '+' : '−'} {formatarBRL(transacao.valorCentavos)}
      </span>
    </button>
  );
}
